import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Plus, Save } from "lucide-react";

export default function AddWeeklyGoalDialog({ lojas, novaMeta, setNovaMeta, onSalvar }) {
  const [open, setOpen] = useState(false);

  const salvar = async () => {
    const ok = await onSalvar();
    if (ok) setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          className="flex flex-col items-center justify-center min-h-[220px] p-6 bg-transparent rounded-2xl border-2 border-dashed border-slate-200 hover:bg-slate-50/50 hover:border-blue-400 hover:text-blue-600 transition-all duration-200 cursor-pointer text-slate-500"
          data-testid="add-weekly-goal-button"
        >
          <div className="p-4 bg-white rounded-full shadow-sm border border-slate-100 mb-3">
            <Plus className="w-6 h-6" />
          </div>
          <span className="text-sm font-semibold tracking-wide">Adicionar Meta Semanal</span>
        </button>
      </DialogTrigger>

      <DialogContent className="sm:max-w-md rounded-2xl" data-testid="add-weekly-goal-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-slate-900">
            <Plus className="w-5 h-5 text-blue-600" /> Adicionar Meta Semanal
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="space-y-1.5">
            <Label className="text-xs text-slate-500">Loja</Label>
            <Select value={novaMeta.loja} onValueChange={(v) => setNovaMeta({ ...novaMeta, loja: v })}>
              <SelectTrigger data-testid="add-weekly-loja"><SelectValue placeholder="Selecione a loja" /></SelectTrigger>
              <SelectContent>
                {lojas.map((l) => <SelectItem key={l} value={l}>{l}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5">
              <Label className="text-xs text-slate-500">Data Início</Label>
              <Input
                type="date"
                value={novaMeta.data_inicio}
                onChange={(e) => setNovaMeta({ ...novaMeta, data_inicio: e.target.value })}
                data-testid="add-weekly-inicio"
              />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs text-slate-500">Data Fim</Label>
              <Input
                type="date"
                value={novaMeta.data_fim}
                onChange={(e) => setNovaMeta({ ...novaMeta, data_fim: e.target.value })}
                data-testid="add-weekly-fim"
              />
            </div>
          </div>

          <div className="space-y-1.5">
            <Label className="text-xs text-slate-500">Valor da Meta (R$)</Label>
            <Input
              type="number"
              step="0.01"
              placeholder="0.00"
              value={novaMeta.valor_meta}
              onChange={(e) => setNovaMeta({ ...novaMeta, valor_meta: e.target.value })}
              data-testid="add-weekly-valor"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)} className="rounded-xl">Cancelar</Button>
          <Button onClick={salvar} className="rounded-xl bg-blue-600 hover:bg-blue-700" data-testid="add-weekly-salvar">
            <Save className="w-4 h-4 mr-1" /> Salvar Meta
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
